module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "left-panel small",
    attrs: {
      "id": "left-panel"
    }
  }, [_c('div', {
    staticClass: "left-panel-inner"
  }, [_c('div', {
    staticClass: "left-panel-profil"
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "in-out"
    }
  }, [(_vm.avatar == 'assets/img/anon.jpg' || _vm.avatar == _vm.db_avatar) ? _c('div', {
    key: "1",
    staticClass: "avatar",
    style: ({
      backgroundImage: 'url(' + _vm.db_avatar + ')'
    })
  }) : _vm._e(), _vm._v(" "), (_vm.avatar != 'assets/img/anon.jpg' && _vm.avatar != _vm.db_avatar) ? _c('div', {
    key: "2",
    staticClass: "avatar",
    style: ({
      backgroundImage: 'url(' + _vm.avatar + ')'
    })
  }) : _vm._e()]), _vm._v("\n      " + _vm._s(_vm.user_name) + "\n      "), _c('span', [_vm._v(_vm._s(_vm.group_name))])], 1), _vm._v(" "), _c('ul', {
    staticClass: "left-panel-profil-menu"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/logout'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-power-off"
  })])], 1)]), _vm._v(" "), _c('h5', {
    staticClass: "sidebar-title",
    staticStyle: {
      "margin-bottom": "0px"
    }
  }, [_vm._v("Menü")]), _vm._v(" "), _c('ul', {
    staticClass: "left-panel-menu",
    attrs: {
      "id": "left-panel-menu"
    }
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/home'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-home"
  }), _vm._v(" "), _c('span', [_vm._v("Kezdőoldal")])])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/users/list'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-user"
  }), _vm._v(" "), _c('span', [_vm._v("Felhasználók")])])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/card_owners/list'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-address-card-o"
  }), _vm._v(" "), _c('span', [_vm._v("Kártyabirtokosok")])])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/card/list'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-credit-card"
  }), _vm._v(" "), _c('span', [_vm._v("Kártyák")])])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/maintenance'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-wrench"
  }), _vm._v(" "), _c('span', [_vm._v("Karbantartás")])])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/log'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-info"
  }), _vm._v(" "), _c('span', [_vm._v("Log")])])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/logout'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-power-off"
  }), _vm._v(" "), _c('span', [_vm._v("Kilépés")])])], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-19eb1cea"}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/tpl_leftpanel.vue
// module id = 47
// module chunks = 0